import React from 'react';
import {connect} from 'react-redux';


class ResponseHeader extends React.Component
{
    render(){
        var responseHeader = this.props.responseHeaders;
        if(responseHeader != null)
        {
            responseHeader = <div id ="responseHeader">
            { 
                Object.keys(this.props.responseHeaders).map((key, i) => {
                    if(i%2==0)
                    {
                        return (<tr key={i} class="oddRow">
                        <td class ="key">{key}</td>
                        <td class = "value">{this.props.responseHeaders[key]}</td>
                      </tr>)
                    }
                    else
                    {
                        return(<tr key={i} class="evenRow">
                        <td class ="key">{key}</td>
                        <td class = "value">{this.props.responseHeaders[key]}</td>
                        </tr>)
                    }
                })                      
            }
            </div>
        }
        else
        {
            responseHeader =  <div id ="responseHeader">
            </div>  
        }
        return(         
        
               <span>
                   {responseHeader}
                   </span>
            
        )
    };
}

function mapStateToProps(state){
    return{
        responseHeaders: state.rhsReducer.responseHeaders
  }
}
export default connect(mapStateToProps)(ResponseHeader);